import React from 'react';
import {useIntl} from 'react-intl';
import {DatePicker} from 'antd';
import locale from 'antd/es/date-picker/locale/he_IL';
import dayjs from 'dayjs';
import 'dayjs/locale/he';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';


const FilterToDate = ({
                        values,
                        handleSubmit,
                        setFieldValue,
                        placeholder = '',
                        containerStyles = 'col-lg',
                        customClearDate = null,
                        ...rest
                      }) => {

  const intl = useIntl();
  const searchByToDate = intl.formatMessage({
    id: 'invoices-filter-toDate',
    defaultMessage: 'To date',
  });
  const placeholderText = placeholder
    ? placeholder
    : searchByToDate;

  return (
    <div className={containerStyles}>
      <DatePicker
        value={values.toDate ? dayjs(values.toDate) : null}
        className="form-control datepicker-form-control d-flex"
        placeholder={values.toDate
          ? dayjs(values.toDate).format('DD-MM-YYYY')
          : placeholderText
        }
        onChange={(date) => {
          if (date) {
            setFieldValue('toDate', dayjs(date.$d).format('YYYY-MM-DD'));
          }
          handleSubmit();
        }}
        locale={locale}
        format={'DD-MM-YYYY'}
        clearIcon={
          <img
            src={toAbsoluteUrl('/media/svg/Cross_brandColor.svg')}
            alt="clear-filter"
            className="clear-datepicker-icon"
            onClick={() => {
              if (customClearDate) {
                customClearDate();
              } else {
                setFieldValue('toDate', '');
              }
              handleSubmit();
            }}
          />
        }
        suffixIcon={false}
        showToday={false}
        disabledDate={(current) => {
          if (values.fromDate) {
            return current && current < dayjs(values.fromDate);
          }
        }}
        {...rest}
      />
    </div>
  );
};

export default FilterToDate;
